export const MAX_SINGLE_ROW_OPTIONS = 2;

export const TEST_ID = 'toggle';
